// type – true тексты для средних, false – для младших
export default (type = true) => [
  {
    imageFound: require('./item1.found.svg'),
    found: false,
    hasRightAnswer: false,
    domID: 'clock',
    animation: require('./json/02_Room_AlarmClock.json'),
    about: [
      {
        title: 'Какие данные может собирать будильник?',
        text: type
          ? 'В какое время человек просыпается чаще всего? Как часто нажимает кнопку «Поспать ещё»?\n\nВ какое время  просыпаются чаще всего люди в данном населённом пункте?'
          : 'В какое время человек просыпается чаще всего? Как часто нажимает кнопку «Поспать ещё»?\n\n В какое время  просыпаются чаще всего люди в данном населённом пункте?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Облегчаем подъём — включаем звуковой сигнал в тот момент, когда человеку будет проснуться проще всего. Включаем вовремя кофеварку, чайник и тостер, чтобы завтрак был готов к тому моменту, когда человек встанет. \n\n Передать данные о числе бодрствующих людей, позволяя электростанциям снизить выработку электричества в «тихие»‎ часы, экономя  при этом топливо.'
          : 'Включаем вовремя кофеварку, чайник и тостер, чтобы завтрак был готов к тому моменту, когда человек встанет. \n\n Передать данные о числе бодрствующих людей, позволяя электростанциям снизить выработку электричества в «тихие»‎ часы, экономя  при этом топливо.',
      },
    ],
    question: 'Как умный будильник может помочь сберечь природу?',
    answers: [
      {
        id: 0,
        text: 'Не будить ребёнка в школу, чтобы у него была удобная отговорка',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Собрать данные о характеристиках сна человека',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'Передать данные о числе бодрствующих людей, позволяя электростанциям снизить выработку электричество в «тихие» часы, экономя  при этом топливо',
        isCorrect: true,
      },
      {
        id: 3,
        text: 'Выбирать подходящие для пробуждения звуки',
        isCorrect: false,
      },
    ],
  },
  {
    imageFound: require('./item2.found.svg'),
    found: false,
    hasRightAnswer: false,
    domID: 'lamp',
    animation: require('./json/02_Room_Light.json'),
    about: [
      {
        title: 'Какие данные может собирать умная лампочка?',
        text: type
          ? 'Какую яркость света настраивает пользователь? Как выбранная яркость изменяется в течение дня?\n\nЕсть ли поблизости человек в тёмное время суток.'
          : 'Какую яркость света настраивает пользователь? Как выбранная яркость изменяется в течение дня?\n\nЕсть ли поблизости человек в тёмное время суток.',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Автоматически меняем освещение в течение дня. \n\n Включаем лампочку в подъезде, только когда там появляются люди, в остальное время экономим электричество.'
          : 'Автоматически меняем освещение в течение дня. \n\n Включаем лампочку в подъезде, только когда там появляются люди, в остальное время экономим электричество.',
      },
    ],
    question: 'В чем польза умной лампочки?',
    answers: [
      {
        id: 0,
        text: 'Отапливает квартиру',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Может превращаться в дискошар',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'На неё не летят насекомые',
        isCorrect: false,
      },
      {
        id: 3,
        text: 'Поможет сэкономить электричество',
        isCorrect: true,
      },
    ],
  },
  {
    imageFound: require('./item3.found.svg'),
    found: false,
    hasRightAnswer: false,
    domID: 'meteo',
    animation: require('./json/02_Room_Meteostation.json'),
    about: [
      {
        title: 'Какие данные может собирать домашняя метеостанция?',
        text: type
          ? 'Какая температура на улице? В доме? Каковы уровни содержания углекислого газа и влажности в комнате?\n\n Как отличаются метеопоказатели от дома к дому? От района к району?'
          : 'Какая температура на улице? В доме? Каковы уровни содержания углекислого газа и влажности в комнате?\n\n Как отличаются метеопоказатели от дома к дому? От района к району?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Управляем метеотехникой: автоматически включаем кондиционеры, обогреватели, вентиляторы для поддержания идеальных условий.\n\n Составляем карту метеопоказателей города/района. Высаживаем деревья там, где повышенный уровень углекислого газа. Находим дома, требующие ремонта вентиляции.'
          : 'Управляем метеотехникой: автоматически включаем кондиционеры, обогреватели, вентиляторы для поддержания идеальных условий.\n\n Составляем карту метеопоказателей города/района. Высаживаем деревья там, где повышенный уровень углекислого газа. Находим дома, требующие ремонта вентиляции.',
      },
    ],
    question: 'Как домашние метеостанции могут помочь учёным?',
    answers: [
      {
        id: 0,
        text: 'Майнить биткоины',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Собирать данные о погоде по всему городу из множества точек',
        isCorrect: true,
      },
      {
        id: 2,
        text: 'Фотографировать птиц',
        isCorrect: false,
      },
      {
        id: 3,
        text: 'Предсказывать погоду',
        isCorrect: false,
      },
    ],
  },
  {
    imageFound: require('./item4.found.svg'),
    found: false,
    hasRightAnswer: false,
    domID: 'pc',
    animation: require('./json/02_Room_PC.json'),
    about: [
      {
        title: 'Какие данные может собирать компьютер?',
        text: type
          ? 'Какие сайты чаще всего посещает пользователь? Как много времени на них проводит? Какую информацию ищет в сети?\n\n Голосовые команды, фразы, произнесённые пользователем.'
          : 'Какие сайты чаще всего посещает пользователь? Как много времени на них проводит? Какую информацию ищет в сети?',
      },
      {
        title: 'Как можно использовать эти данные?  ',
        text: type
          ? 'Исследуем запросы  пользователей, предлагаем наиболее интересное содержание.\n\nУлучшаем голосовой помощник, опознаём пользователя по голосу, создаём человеко-подобный искусственный голос.'
          : 'Исследуем запросы  пользователей в сети, предлагаем наиболее интересное содержание.',
      },
    ],
    question: 'Почему данные о поисковых запросах в сети так ценны?',
    answers: [
      {
        id: 0,
        text: 'Они позволяют сэкономить место на жёстком диске пользователя',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Они позволяют лучше понимать интересы пользователей и улучшать результаты поиска',
        isCorrect: true,
      },
      {
        id: 2,
        text: 'Их можно использовать, чтобы сберегать электричество',
        isCorrect: false,
      },
      {
        id: 3,
        text: 'В них нет никакой ценности и пользы',
        isCorrect: false,
      },
    ],
  },
  {
    imageFound: require('./item5.found.svg'),
    found: false,
    hasRightAnswer: false,
    domID: 'phone',
    animation: require('./json/O2_Room_Phone.json'),
    about: [
      {
        title: 'Какие данные может собирать смартфон?',
        text: type
          ? 'Экранное время — показывает сколько времени в течение дня человек пользовался смартфоном. \n\n Какую музыку человек слушает чаще всего?'
          : 'Экранное время — показывает сколько времени в течение дня человек пользовался смартфоном. \n\n Какую музыку человек слушает чаще всего?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Присылать напоминания о необходимости отдыха, если кто-то засиделся в телефоне. \n\n Рекомендовать музыкальных исполнителей, которые точно понравятся.'
          : 'Присылать напоминания о необходимости отдыха, если кто-то  засиделся в телефоне. \n\n Рекомендовать музыкальных исполнителей, которые точно понравятся.',
      },
    ],
    question: 'Какие данные может собирать смартфон?',
    answers: [
      {
        id: 0,
        text: 'Оценки, полученные за контрольные работы',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Время, проведённое за компьютером/телевизором',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'Время, проведённое в разных приложениях',
        isCorrect: true,
      },
      {
        id: 3,
        text: 'Что владелец телефона ел на завтрак',
        isCorrect: false,
      },
    ],
  },
  {
    imageFound: require('./item6.found.svg'),
    found: false,
    hasRightAnswer: false,
    domID: 'tv',
    animation: require('./json/02_Room_TV.json'),
    about: [
      {
        title: 'Какие данные может собирать умный телевизор?',
        text: type
          ? 'Какие каналы просматриваются чаще всего? Как долго зритель смотрит рекламу, прежде чем переключается на другой канал?\n\n В какое время суток телезрители чаще включают телевизор?'
          : 'Какие каналы просматриваются чаще всего? В какое время суток  телезрители чаще включают телевизор?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Предлагаем передачи, сюжеты которых больше всего нравятся зрителю. Подбираем идеальную продолжительность времени  рекламы. \n\n Составляем сетку вещания: лучшие передачи ставим в то время, когда зритель, с наибольшей вероятностью включит телевизор.\n'
          : 'Предлагаем передачи, сюжеты которых больше всего нравятся зрителю. Лучшие передачи ставим в то время, когда зритель, с наибольшей вероятностью включит телевизор.',
      },
    ],
    question: 'Какие данные может собирать умный телевизор?',
    answers: [
      {
        id: 0,
        text: 'Надёжность домашней электросети',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Художественную ценность телепередач',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'Предпочтения в телепередачах',
        isCorrect: true,
      },
      {
        id: 3,
        text: 'Продолжительность сна владельца',
        isCorrect: false,
      },
    ],
  },
]
